module.exports = __webpack_public_path__ + "img/button-primary.50e9061b.svg";